export class TranslationBundle {
    translations = {};
    constructor(translations) {
        if (translations) {
            this.translations = translations;
        }
    }
}
